<div class="card" id="quote-pdf-pages">
    <app-aul-101-24 [quoteDetails]="this.quoteDetails()"></app-aul-101-24>
    <br/>
    <app-aul-102-24 [quoteDetails]="this.quoteDetails()"></app-aul-102-24>
    <br/>
    <app-aul-103-24 [quoteDetails]="this.quoteDetails()"></app-aul-103-24>
    <br/>
    <app-aul-106-24></app-aul-106-24>
    <br/>
    <!-- <app-aul-104-24></app-aul-104-24> -->
</div>
@if(this.isGeneratingPDF()) {
<app-spinner></app-spinner>
}
